import request from '@/utils/http'
import { SRM_FILE_PRE, PFX } from '../constant/constant.js'
// 公告列表接口
export const noticeManager = params => {
    return request({
        url: `/api-srm-web/bid/queryNoticeManagerPage`,
        method: 'post',
        data: params,
    })
}

// 公告删除接口
export const delNotice = id => {
    return request({
        url: `/api-srm-web/bid/bidNotice/${id}`,
        method: 'delete',
    })
}

// 公告详情接口
export const getNotice = id => {
    return request({
        url: `/api-srm-web/bid/bidNotice/${id}`,
        method: 'get',
    })
}

// 供应商公告详情接口
export const getSupNotice = params => {
    return request({
        url: `/api-srm-web/bid/portal/bidNoticeSupplier`,
        method: 'post',
        data: params,
    })
}

// 公告新增接口
export const addNotice = params => {
    return request({
        url: `/api-srm-web/bid/bidNotice?noticeApplyNo=${params.noticeApplyNo}`,
        method: 'post',
        data: params,
    })
}

// 公告修改接口
export const editorNotice = (params, id, par) => {
    let urlpar = ''
    if (JSON.stringify(par) !== '{}') {
        const key1 = Object.keys(par)[0]
        const key2 = Object.keys(par)[1]
        const key3 = Object.keys(par)[2]
        urlpar = `?${key1}=${par[key1]}&${key2}=${par[key2]}&${key3}=${par[key3]}`
    }
    return request({
        url: `/api-srm-web/bid/bidNotice/${id}${urlpar}`,
        method: 'put',
        data: params,
    })
}

export const publishNotice = (params, id, par) => {
    let urlpar = ''
    if (JSON.stringify(par) !== '{}') {
        const key1 = Object.keys(par)[0]
        const key2 = Object.keys(par)[1]
        const key3 = Object.keys(par)[2]
        urlpar = `?${key1}=${par[key1]}&${key2}=${par[key2]}&${key3}=${par[key3]}`
    }
    return request({
        url: `/api-srm-web/bid/publishNotice/${id}${urlpar}`,
        method: 'post',
        data: params,
    })
}

// 公告附件新增接口
export const addFile = params => {
    return request({
        url: `/api-srm-web/bid/bidModuleFile`,
        method: 'post',
        data: params,
    })
}

// 公告附件查询接口
export const moduleFile = params => {
    return request({
        url: `/api-srm-web/bid/bidModuleFile/getBidModuleFiles`,
        method: 'post',
        data: params,
    })
}

// 公告附件删除接口
export const delModuleFile = params => {
    return request({
        url: `/api-srm-web/bid/bidModuleFile/${params}`,
        method: 'delete',
    })
}

// 供应商列表接口
export const supplierInfo = params => {
    return request({
        url: `/api-srm-web/supplier/supplierInfo/query/bid`,
        method: 'get',
        params: params,
    })
}

// 公告详情供应商保存接口
export const insertSupplier = params => {
    return request({
        url: `/api-srm-web/bid/insertBidNoticeSupplier`,
        method: 'post',
        data: params,
    })
}

// 公告详情供应商查询接口
export const bidNoticeSuppliers = params => {
    return request({
        url: `/api-srm-web/bid/bidNoticeSuppliers`,
        method: 'post',
        data: params,
    })
}

// 删除供应商接口
export const delSupplier = id => {
    return request({
        url: `/api-srm-web/bid/bidNoticeSupplier/${id}`,
        method: 'delete',
    })
}

// 我要报名接口
export const signUp = params => {
    return request({
        url: `/api-srm-web/bid/queryContactsByUserCode`,
        method: 'post',
        data: params,
    })
}

// 配置列接口
export const getList = {
    post(params) {
        return request({
            url: '/api-auth/userIndividualConfigs/saveOrUpdate',
            method: 'post',
            data: params,
        }).then(res => res)
    },
    get(params) {
        return request({
            url: '/api-auth/userIndividualConfigs/param',
            method: 'post',
            data: params,
        }).then(res => res)
    },
}

// 创建mip流程
export const getMipUrl = params => {
    return request({
        url: `/api-srm-web/bid/noticeIflowCreateDraft?noticeApplyNo=${params.noticeApplyNo}&specialNoticeAudit=0`,
        method: 'post',
        data: params,
    })
}
// 创建特权mip流程
export const getPrivilegeMipUrl = params => {
    return request({
        url: `/api-srm-web/bid/noticeIflowCreateDraft?noticeApplyNo=${params.noticeApplyNo}&specialNoticeAudit=1`,
        method: 'post',
        data: params,
    })
}
// 提交mip审核
export const createProcess = params => {
    return request({
        url: `/api-iflow/approveProcess?tenantCode=${params.tenantCode}&appCode=${params.currentApplicationCode}`,
        method: 'post',
        data: params,
    }).then(res => res)
}

// 获取 iflow 流程所需的 token
export const ssoLoginLc = data => {
    return request({
        url: `/api-auth/ssoLoginLc`,
        method: 'post',
        data,
    })
}

// 获取 iflow 流程所需的 token
export const signInFromToken = data => {
    return request({
        url: `/api-auth/signInFromToken`,
        method: 'post',
        data,
    })
}

// 查询mip流程
export const queryOneInstance = params => {
    return request({
        url: `/api-iflow/queryOneInstance`,
        method: 'post',
        data: params,
    }).then(res => res)
}

// mip报错信息查询
export const getProcessInfo = params => {
    return request({
        url: `/api-iflow/getProcessInfo`,
        method: 'post',
        data: params,
    }).then(res => res)
}

// 导出
export const exportNotice = params => {
    return request({
        url: `${SRM_FILE_PRE}/bid/exportNoticeSupplier`,
        method: 'post',
        data: params,
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 查询此供应商是否是黑名单供应商
export const checkIsBlackSupplier = id => {
    return request({
        url: `/api-srm-web/supplier/checkIsBlackSupplier/${id}`,
        method: 'get',
    })
}
// 保存公告校验
export const bidNoticeCreateValid = (data, query) => {
    let url = `/api-srm-web/bid/bidNotice/createValid?noticeApplyNo=${data.noticeApplyNo}`
    if (query.specialChange) {
        url += `&specialChange=${query.specialChange}`
    }
    return request({
        url,
        method: 'post',
        data,
    })
}

// 获取客户类型和专业公司
export const queryPlanByNoticeApplyNo = params => {
    return request({
        url: `/api-srm-web/bid/queryPlanByNoticeApplyNo`,
        method: 'get',
        params,
    })
}

// 公告管理-业务规模字段卡控逻辑
export const limitValid = data => {
    return request({
        url: `/api-srm-web/bid/bidNotice/businessScale/limitValid`,
        method: 'post',
        data,
    })
}

// 公告管理-未按要求公开招标流程审批提交
export const iFlowCreate = data => {
    return request({
        url: `/api-srm-web/bid/bidNotice/businessScale/iFlowCreate`,
        method: 'post',
        data,
    })
}

// 公告管理查看-获取业务编码最新审批流程
export const queryNewestAuditRecordByBizCodeList = data => {
    return request({
        url: `/api-srm-web/bid/bidAudit/queryNewestAuditRecordByBizCodeList`,
        method: 'post',
        data,
    })
}
// 提示配置
export const warningTip = data => {
    return request({
        url: `/api-srm-web/bid/bidNotice/apply/warningTip`,
        method: 'post',
        data,
    })
}

// 召回公告
export const bidRecallNotice = data => {
    return request({
        url: `${PFX}/bid/bidNotice/bidRecallNotice`,
        method: 'post',
        data,
    })
}

// 项目公告下载模版
export const downloadProjectNoticeFile = params => {
    return request({
        url: `/api-srm-file/bid/bidNotice/moduleFile/download`,
        method: 'get',
        params,
    })
}

// 项目公告报名明细弹窗
export const getBidNoticeEnrollDetails = data => {
    return request({
        url: `/api-srm-web/bid/bidNotice/enrollDetails/query`,
        method: 'post',
        data,
    })
}
